import { useEffect } from 'react'
import type { Filter } from 'src/Types/Filter'
import { FilterType } from 'src/Types/Filter'
import type { Asset } from 'src/Types/AssetTypes'

export const getAvailableIds = (idFilterAssets: Asset[]): string[] => {
  return idFilterAssets.map(a => `${a.baneDataId}-${a.assetType}`)
}

export const getMatchingIds = (currentIds: string[], availableIds: string[]): string[] => {
  return currentIds.filter(id => availableIds.includes(id))
}

export const updateFilters = (filters: Filter[], matchingIds: string[]): Filter[] => {
  const filtersWithoutAssetId = filters.filter((f): f is Filter => f.type !== FilterType.AssetId)
  if (matchingIds.length > 0) {
    filtersWithoutAssetId.push({ type: FilterType.AssetId, values: matchingIds })
  }
  return filtersWithoutAssetId
}

/**
 * This is a custom hook that will sync the id filter with the available assets.
 */
export const useSyncIdFilter = (filters: Filter[], idFilterAssets: Asset[], setFilters: (filters: Filter[]) => void) => {
  useEffect(() => {
    const assetIdFilter = filters.find(f => f.type === FilterType.AssetId)
    if (assetIdFilter) {
      const currentIds = assetIdFilter.values
      const availableIds = getAvailableIds(idFilterAssets)
      const matchingIds = getMatchingIds(currentIds, availableIds)
      if (matchingIds.length !== currentIds.length) {
        const updatedFilters = updateFilters(filters, matchingIds)
        setFilters(updatedFilters)
      }
    }
  }, [filters, idFilterAssets, setFilters])
}
